import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";
import { env } from "@/shared/config/env";

export const PostHogPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (env.VITE_POSTHOG_KEY) {
      posthog.capture("$pageview");
    }
  }, [location]);

  return null;
};
